import { useCallback } from "react";
import { registerService } from "../service-provider/ServiceRegistry";
import useSessionStorage from "../storage/SessionStorageService";

const MainMenuOpenStateStorageKey = "MainMenuOpenState";

export interface MainMenuStorageService {
  setMainMenuOpenState(value: boolean): void;
  getMainMenuOpenState(): boolean;
}

function useMainMenuStorage(): MainMenuStorageService {
  const { setStorageItem, getStorageItem } = useSessionStorage();

  const setMainMenuOpenState = useCallback(
    (value: boolean) => {
      setStorageItem(MainMenuOpenStateStorageKey, value.toString());
    },
    [setStorageItem]
  );

  const getMainMenuOpenState = useCallback((): boolean => {
    const openMainMenuInitialValue = getStorageItem(MainMenuOpenStateStorageKey);
    if (openMainMenuInitialValue) return !!JSON.parse(openMainMenuInitialValue);

    return true;
  }, [getStorageItem]);

  return {
    setMainMenuOpenState,
    getMainMenuOpenState,
  };
}

export default registerService(useMainMenuStorage);
